import * as React from 'react';
import { IconProps } from '../types';

const IcArrange = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <circle cx={7.577} cy={2.769} r={2.769} fill={props?.fill ?? '#232F3E'} />
    <circle cx={17.423} cy={2.769} r={2.769} fill={props?.fill ?? '#232F3E'} />
    <circle cx={7.577} cy={12} r={2.769} fill={props?.fill ?? '#232F3E'} />
    <circle cx={17.423} cy={12} r={2.769} fill={props?.fill ?? '#232F3E'} />
    <circle cx={7.577} cy={21.231} r={2.769} fill={props?.fill ?? '#232F3E'} />
    <circle cx={17.423} cy={21.231} r={2.769} fill={props?.fill ?? '#232F3E'} />
  </svg>
);

export default IcArrange;
